import { Link, useNavigate } from "react-router-dom";
import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import { Site, ZoneConfig } from "../../model/model";
import ZoneForm from "./ZoneForm";
import SessionStore from "../../model/SessionStore";

function CreateSiteZone({ site }: { site: Site }) {
  const navigate = useNavigate();

  const onFinish = (obj: ZoneConfig) => {
    obj.siteId = site.id;
    SessionStore.getClient().createZoneConfig(obj, SessionStore.getBearer()).then(() => {
      navigate(`/site/${site.id}/zones`);
    });
  };

  const initial: ZoneConfig = {
    id: "",
    name: "",
    siteId: site.id,
    devId: "",
    zones: [],
    millis: 5000,
    checkIntervalSecond: 60,
    parallelAllowed: false,
    weekDays: [],
    hours: [],
    onTimeMinute: 0,
    logEnabled: false,
    notifications: {},
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/site/${site.id}/dash`}>{site.name}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/site/${site.id}/zones`}>Zone Configs</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add Zone Config"
      />
      <Card>
        <ZoneForm initialValues={initial} site={site} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateSiteZone;
